module.exports = __webpack_public_path__ + "img/camurus-logo_enrad_rgb.4cea4b4a.png";